export const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000;
export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
export const DEFAULT_EVENT_DURATION = 60 * 60 * 1000; // 60 mins in millis